/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_PgvectorInputs */

const en_svchip_pgvector = /** @type {(inputs: Svchip_PgvectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pgvector`)
};

const ar_svchip_pgvector = /** @type {(inputs: Svchip_PgvectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pgvector`)
};

const bn_svchip_pgvector = /** @type {(inputs: Svchip_PgvectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pgvector`)
};

const de_svchip_pgvector = /** @type {(inputs: Svchip_PgvectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pgvector`)
};

const es_svchip_pgvector = /** @type {(inputs: Svchip_PgvectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pgvector`)
};

const fr_svchip_pgvector = /** @type {(inputs: Svchip_PgvectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pgvecteur`)
};

const pt_svchip_pgvector = /** @type {(inputs: Svchip_PgvectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pgvetor`)
};

const zh_svchip_pgvector = /** @type {(inputs: Svchip_PgvectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pg向量`)
};

const tr_svchip_pgvector = /** @type {(inputs: Svchip_PgvectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pgvektör`)
};

const ru_svchip_pgvector = /** @type {(inputs: Svchip_PgvectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`пгвектор`)
};

const pl_svchip_pgvector = /** @type {(inputs: Svchip_PgvectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pgwektor`)
};

/**
* | output |
* | --- |
* | "pgvector" |
*
* @param {Svchip_PgvectorInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_pgvector = /** @type {((inputs?: Svchip_PgvectorInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_PgvectorInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_pgvector(inputs)
	if (locale === "bn") return bn_svchip_pgvector(inputs)
	if (locale === "de") return de_svchip_pgvector(inputs)
	if (locale === "es") return es_svchip_pgvector(inputs)
	if (locale === "fr") return fr_svchip_pgvector(inputs)
	if (locale === "pt") return pt_svchip_pgvector(inputs)
	if (locale === "zh") return zh_svchip_pgvector(inputs)
	if (locale === "tr") return tr_svchip_pgvector(inputs)
	if (locale === "ru") return ru_svchip_pgvector(inputs)
	if (locale === "pl") return pl_svchip_pgvector(inputs)
	return en_svchip_pgvector(inputs)
});